/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmbeddedMap = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14 20h6v-6h2v8H12v-8h2z" />
        <path d="M19 18h-4v-2h4zM7 4H4v9h6v2H2V2h5z" />
        <path d="M12.707 3.707 11.414 5H18v5.586l1.293-1.293 1.414 1.414L17 14.414l-3.707-3.707 1.414-1.414L16 10.586V7h-4.586l1.293 1.293-1.414 1.414L7.586 6l3.707-3.707zM8 12H5v-2h3zM7 9H5V7h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmbeddedMap as EmbeddedMap };
